class HHCollectionHeaderCarousel extends HTMLElement {
  constructor() {
    super()

    this.mainGallery = null
    this.sectionId = this.getAttribute('data-section-id')
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.mainGallery = new Swiper(`[data-section-id='${this.sectionId}'] .swiper`, {
      spaceBetween: 5,
      slidesPerView: 'auto',
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      navigation: {
        nextEl: document.querySelector(`[data-section-id='${this.sectionId}'].swiper-nav-btn-next`),
        prevEl: document.querySelector(`[data-section-id='${this.sectionId}'].swiper-nav-btn-prev`),
      },
      breakpoints: {
        990: {
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
        },
      },
    })
  }
}

customElements.define(
  'hh-collection-header-carousel',
  HHCollectionHeaderCarousel
)
